var map = {
	"./ikon-de.png": "e3a4",
	"./ikon-de_l.png": "9edd",
	"./ikon-en.png": "8e53",
	"./ikon-en_l.png": "3046",
	"./ikon-ru.png": "a525",
	"./ikon-ru_l.png": "2057",
	"./ikon-sv.png": "7073",
	"./ikon-sv_l.png": "c3bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d0eb";